import React, { useRef, useState }  from 'react';
import { Modal, Form, Button }      from 'react-bootstrap';
import { useDispatch }              from 'react-redux';
import { Formik }                   from 'formik';
import * as yup                     from 'yup';

import ButtonSpinner                from '../layout/ButtonSpinner';

import { ICON_SAVE, ICON_CANCEL }   from '../extras/icons';
import { updateProfileAction }      from '../../actions/authActions';



const ProfileForm = props => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Tomo los props
    const { handleClose, show, user } = props;

    // Genero los ref
    const refApellido = useRef();

    // Inicializo datos
    const initialData = {
        apellido: user ? user.apellido : '',
        email: user ? user.email : '',
        nombre: user ? user.nombre : '',
    }

    // Inicializo el state local
    const [loading, setLoading] = useState(false);



    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo evento de apertura
    const handleOnShow = () => {
        refApellido.current.focus();
    }

    // Manejo el guardado
    const handleSave = values => {
        //Armo los datos
        const data = {
            apellido: values.apellido,
            email: values.email,
            nombre: values.nombre,
        }
        //Llamo al dispatch
        dispatch( updateProfileAction(data, handleClose) );
    }

    // Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        email: yup.string().email().required(),
        nombre: yup.string().required(),
    });
    


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            show = { show } 
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Perfil
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                initialValues = {{ ...initialData }}
                onSubmit = { values=>handleSave(values) }
                validationSchema = { validationSchema }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        A continuación puede editar sus datos personales
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        autoFocus 
                                        className = "form-control" 
                                        disabled = { loading }
                                        id = "apellido"
                                        isInvalid = { !!errors.apellido }
                                        name = "apellido" 
                                        onChange = { handleChange }
                                        placeholder = "Ingrese apellido"
                                        ref = { refApellido }
                                        type = "text" 
                                        value = { values.apellido }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { loading }
                                        id = "nombre"
                                        isInvalid = { !!errors.nombre }
                                        name = "nombre" 
                                        onChange = { handleChange }
                                        placeholder = "Ingrese nombre"
                                        type = "text" 
                                        value = { values.nombre }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { loading }
                                        id = "email"
                                        isInvalid = { !!errors.email }
                                        name = "email" 
                                        onChange = { handleChange }
                                        placeholder = "Ingrese email"
                                        type = "text" 
                                        value = { values.email }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Label>Perfil</Form.Label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { true }
                                        type = "text" 
                                        value = { user.perfil.descripcion }
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Label>Nivel</Form.Label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { true }
                                        type = "text" 
                                        value = { user.nivel.descripcion }
                                    />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ loading }>
                                            <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ProfileForm;
